import React from 'react';

interface Props {
  fillColor?: string;
}
function TonsilsIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none">
      <g clipPath="url(#clip0_847_3107)">
        <path
          d="M10.5 6.35547C10.5 3.87109 8.48438 1.85547 6 1.85547C3.51562 1.85547 1.5 3.87109 1.5 6.35547V11.8555C1.5 13.5117 2.84375 14.8555 4.5 14.8555C6.15625 14.8555 7.5 13.5117 7.5 11.8555C7.5 11.1773 7.84062 10.5242 8.43125 10.143C9.67812 9.33984 10.5 7.94297 10.5 6.35547ZM12 6.35547C12 8.47422 10.9031 10.3367 9.24375 11.4023C9.09062 11.5023 9 11.6711 9 11.8555C9 14.3398 6.98438 16.3555 4.5 16.3555C2.01562 16.3555 0 14.3398 0 11.8555V6.35547C0 3.04297 2.6875 0.355469 6 0.355469C9.3125 0.355469 12 3.04297 12 6.35547ZM4 6.35547V6.98672C4 7.08047 4.05312 7.16797 4.1375 7.21172L4.575 7.43047C5.14062 7.71484 5.49687 8.29297 5.49687 8.92422C5.49687 9.42109 5.27812 9.88984 4.89687 10.2086L3.72813 11.1836C3.40938 11.4492 2.9375 11.4055 2.67188 11.0867C2.40625 10.768 2.45 10.2961 2.76875 10.0305L3.9375 9.05547C3.975 9.02422 4 8.97422 4 8.92422C4 8.85859 3.9625 8.79922 3.90625 8.77109L3.46875 8.55234C2.875 8.25547 2.5 7.64922 2.5 6.98672V6.35547C2.5 4.42109 4.06563 2.85547 6 2.85547C7.93437 2.85547 9.5 4.42109 9.5 6.35547V6.60547C9.5 7.02109 9.16562 7.35547 8.75 7.35547C8.33438 7.35547 8 7.02109 8 6.60547V6.35547C8 5.25234 7.10313 4.35547 6 4.35547C4.89687 4.35547 4 5.25234 4 6.35547Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_847_3107">
          <rect
            width="12"
            height="16"
            fill="white"
            transform="translate(0 0.355469)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TonsilsIcon;
